var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contract.url
    ? _c(
        "a",
        {
          staticClass: "library__card card",
          attrs: { href: _vm.decode(_vm.contract.url) }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card__title" }, [
            _vm._v(_vm._s(_vm.contract.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__description" }, [
            _vm._v("Created: " + _vm._s(_vm.contract.created_time))
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]
      )
    : _c(
        "div",
        {
          staticClass: "library__card card card--faded",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.activateModal($event)
            }
          }
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card__title" }, [
            _vm._v(_vm._s(_vm.contract.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__description" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticClass: "card__view-btn" }, [_vm._v("Request")])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__logo-container" }, [
      _c("div", { staticClass: "card__logo-wrapper" }, [
        _c("div", { staticClass: "card__logo h-center-align" }, [
          _c("span", {
            staticClass: "glyphicon glyphicon-file card__placeholder",
            attrs: { "aria-hidden": "true" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__view-btn" }, [
      _vm._v("Download  "),
      _c("span", {
        staticClass: "glyphicon glyphicon-download",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__logo-container" }, [
      _c("div", { staticClass: "card__logo-wrapper" }, [
        _c("div", { staticClass: "card__logo h-center-align" }, [
          _c("span", {
            staticClass: "glyphicon glyphicon-file card__placeholder",
            attrs: { "aria-hidden": "true" }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }